import type { Action } from '@ngrx/store';
import { createReducer, on } from '@ngrx/store';
import type { TwoFactorAuthState } from '../state/two-factor-auth';
import { initialTwoFactorAuthState } from '../state/two-factor-auth';
import { Set2FactorAuthToken, SetPhone, SetCodeToken } from '../action/two-factor-auth.action';

const twoFactorAuthReducer = createReducer(
  initialTwoFactorAuthState,

  on(Set2FactorAuthToken, (state: TwoFactorAuthState, { twoFactorAuthToken }) => ({ ...state, twoFactorAuthToken })),

  on(SetCodeToken, (state: TwoFactorAuthState, { codeToken }) => ({ ...state, codeToken })),

  on(SetPhone, (state: TwoFactorAuthState, { phone }) => ({ ...state, phone })),

);

export function TwoFactorAuthReducer(state: TwoFactorAuthState, action: Action) {
  return twoFactorAuthReducer(state, action);
}
